import React, { useEffect, useState } from "react";
import { useQuery } from '@apollo/client';
import { GET_ORDERBOOK } from './orderbookQuery';
import Loader from '../../../components/Loader';
import { useParams, Link, useNavigate } from "react-router-dom";
import AddressPresentation from "../PersonalAreaAddress/ShowAddress/AddressPresentation";
import { T } from '../../../utils/I18n/I18n';
import useResponsive from "../../../hooks/useResponsive";
import { useCartContext } from '../../../context/CartContext';
import Prices from '../../BaseCurrencyPrices/Prices';
import './PersonalAreaOrdersDetails.scss';

const PersonalAreaOrdersDetails = () => {
    const { loading, error, data, refetch } = useQuery(GET_ORDERBOOK);
    const history = useNavigate();
    const params = useParams();
    const {isMobile} = useResponsive();
    const [items, setItems] = useState([]);
    const { handleProductAdd } = useCartContext();

    useEffect(() => {
        if(!error && !loading) {
            if(data){
                // eslint-disable-next-line no-return-assign
                setItems(data.customerOrderbook.orders.items.find(({id}) => id === params.ordersDetailsId))
                refetch()
            }
        }
    }, [data, refetch])

    if(error){
        return <h1>{error.message}</h1>
    }

    const addProductsToCart = () => {
        if(items.items){
            items.items.forEach(({product_sku, quantity_ordered}) => {
                handleProductAdd(product_sku, quantity_ordered)
            })
            history("/checkout/cart")
        }
    }

    let subtotalPrice = 0;

    return <div className="orders-details">
        {loading && <Loader />}
        {!loading && !data && <h3>Podatci se nisu ucitali, probajte ponovno</h3>}

        {items && items.number &&
        <div className="orders-details__content">
            <h1><T id="personalArea.oneOrder" />  # {atob(items.id)}</h1>
            <h3><T id="orders.orderStatus" /> {items.status}</h3>
            <div className="orders-details__content__header-text">
                <p><T id="orders.orderDate" />: {items.order_date}</p>
                <p onClick={addProductsToCart}><a href="#"><T id="orders.repeatOrder" /></a></p>
                <p><a href="#" onClick={() => window && window.print()}><T id="orders.printOrder" /></a></p>
                <p className="isBold"><T id="orders.orderedProducts" /></p>
                {items.invoices[0] && <p><Link to={`/customer/account/orders/invoice/${params.ordersDetailsId}`}><T id="personalArea.receipt" /></Link></p>}
                {items.credit_memos[0] && <p><Link to={`/customer/account/orders/creditmemo/${params.ordersDetailsId}`}><T id="orders.refund" /></Link>
                </p>}
                {items.shipments[0] && <p><Link to={`/customer/account/orders/shipment/${params.ordersDetailsId}`}><T id="orders.shipment" /></Link>
                </p>}
            </div>

            <div className="orders-details__content__table">
                <table>

                    {!isMobile &&
                        <thead>
                            <tr>
                                <th><T id="orders.productName" /></th>
                                <th><T id="product.code" /></th>
                                <th><T id="cart.price" /></th>
                                <th><T id="cart.quantity" /></th>
                                <th><T id="cart.total" /></th>
                            </tr>
                        </thead>
                    }

                    {items.items &&
                        items.items.map(({product_name, product_sku, status, quantity_ordered, quantity_refunded,
                                             quantity_returned, quantity_canceled, quantity_shipped, advanced_product_inventory}) => {
                        let unit = '';
                        const shouldUnitShow = advanced_product_inventory && advanced_product_inventory.is_qty_decimal === 'true';
                        if (shouldUnitShow) {
                            if (advanced_product_inventory.unit && advanced_product_inventory.unit.charAt(0) !== '/') {
                                unit = '/' + advanced_product_inventory.unit;
                            }
                        }
                        subtotalPrice += advanced_product_inventory.priceWithoutRounding * quantity_ordered;
                        return <tbody key={product_sku}>
                            <tr>
                                <td className="orders-details__content__table__product-name">
                                    {isMobile && <span className="margin-span"><T id="orders.productName" />:</span>}
                                    {product_name}
                                </td>
                                <td>{isMobile && <span className="margin-span"><T id="product.code" />:</span>}
                                    {product_sku}
                                </td>
                                <td>
                                    {isMobile && <span className="margin-span"><T id="cart.price" />:</span>}
                                    <span className="pink">
                                        <Prices
                                          amount={advanced_product_inventory.priceWithoutRounding}
                                          textNextToPrice={shouldUnitShow && unit}
                                          breakRow
                                          isMinicart
                                        />
                                    </span>
                                </td>
                                <td>
                                    <p>{isMobile && <span className="margin-span"><T id="cart.quantity" />:</span>}
                                        <T id="orders.ordered" /> {quantity_ordered}{advanced_product_inventory && advanced_product_inventory.is_qty_decimal === 'true' ? unit : ''}
                                    </p>
                                    {status !== 'Naručeno' &&
                                    <>
                                        <br/>
                                        <p>{status} {quantity_refunded > 0 && quantity_refunded}
                                            {quantity_returned > 0 && quantity_returned}
                                            {quantity_canceled > 0 && quantity_canceled}
                                            {quantity_shipped > 0 && quantity_shipped}
                                        </p>
                                    </>
                                    }

                                </td>
                                <td>
                                    {isMobile && <span className="margin-span"><T id="cart.total" />:</span>}
                                    <span className="pink">
                                        <Prices
                                          amount={advanced_product_inventory.priceWithoutRounding * quantity_ordered}
                                          isMinicart
                                          breakRow
                                        />
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    })}

                    {items.number &&
                        <tfoot>
                            <tr>
                                <th colSpan="4"><T id="cart.total" /></th>
                                <td><Prices amount={items.total.subtotal.value} isMinicart breakRow /></td>
                            </tr>
                            {items.total.discounts.length !== 0 &&
                            <tr>
                                <th colSpan="4"><T id="orders.discount" /></th>
                                <td>-<Prices amount={items.total.discounts[0].amount.value} isMinicart breakRow /></td>
                            </tr>
                            }
                            <tr>
                                <th colSpan="4"><T id="cartSummary.shipping" /></th>
                                <td>
                                    <Prices amount={items.total.total_shipping.value} isMinicart breakRow />
                                </td>
                            </tr>
                            <tr>
                                <th colSpan="4"><T id="giftWrap.wrapping" /></th>
                                <td>
                                    <Prices
                                      amount={items.gift_wrapping === null ? 0 : items.gift_wrapping.price.value}
                                      isMinicart
                                      breakRow
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th colSpan="4"><T id="cartSummary.taxes" /></th>
                                <td>
                                    {items.total.taxes[1]
                                      ? <Prices
                                            amount={items.total.taxes[0].amount.value + items.total.taxes[1].amount.value}
                                            isMinicart
                                            breakRow
                                        />
                                      : <Prices amount={items.total.taxes[0].amount.value} isMinicart breakRow />
                                    }
                                </td>
                            </tr>
                            <tr>
                                <th colSpan="4"><T id="cartSummary.totalFinal" /></th>
                                <td className="orders-details__content__table__grand-total">
                                    <Prices amount={items.total.grand_total.value} isMinicart breakRow />
                                </td>
                            </tr>
                        </tfoot>
                    }
                </table>

                <div className="orders-details__content__go-back-btn">
                    <Link to="/customer/account/orders"><T id="orders.goBack" /></Link>
                </div>

                {items.shipping_address &&
                    items.shipping_address &&
                        <div className="orders-details__content__addresses">
                            <h2><T id="orders.orderInfo" /></h2>
                             <div className="orders-details__content__addresses-shipping">
                                 <div className="orders-details__content__addresses-shipping-address">
                                     {items.shipping_address ? (
                                         <AddressPresentation address={items.shipping_address} isOrdersbook />
                                     ) : (
                                         <p className="address__no-info"><T id="address.noInfo" /></p>
                                     )}
                                 </div>
                             </div>
                             <div className="orders-details__content__addresses-shipping">
                                 <div className="orders-details__content__addresses-shipping-address">
                                     {items.billing_address ? (
                                         <AddressPresentation address={items.shipping_address} addressType="naplatu" isOrdersbook />
                                     ) : (
                                         <p className="address__no-info"><T id="address.noInfo" /></p>
                                     )}
                                 </div>
                                 <div className="orders-details__content__addresses-shipping-delivery">
                                     <p><strong><T id="orders.paymentMethod" /></strong></p>
                                     <p>{items.payment_methods[0].name}</p>
                                 </div>
                             </div>
                         </div>
                    }
            </div>
        </div>
    }

    </div>
}

export default PersonalAreaOrdersDetails;